import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { MapaCamadasService, ConfiguracaoCamadasMapa } from 'app/services/mapa-camadas/mapa-camadas.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-painel-camadas',
  standalone: true,
  imports: [CommonModule, TranslocoModule],
  templateUrl: './painel-camadas.component.html',
  styleUrl: './painel-camadas.component.css'
})
export class PainelCamadasComponent {
  private readonly mapaCamadasService = inject(MapaCamadasService);
  public readonly camadas$: Observable<ConfiguracaoCamadasMapa> = this.mapaCamadasService.camadas$;

  public alternar(chave: keyof ConfiguracaoCamadasMapa): void {
    this.mapaCamadasService.alternar(chave);
  }
}
